import { createContext, useContext } from "react";

// What I just did on the web, said at once where the trip's notices go, with its Undo (TripPage's UndoNotice): a
// to-do removed, a booking saved, something planned for a day, a question answered, a payment added. Any edit
// inside a trip says it through `useJustDone`; `change` null says it with OK instead of Undo.
export interface Done {
  change: string | null;
  text: string;
}
const JustDone = createContext<(done: Done) => void>(() => {});
export const JustDoneProvider = JustDone.Provider;
export const useJustDone = () => useContext(JustDone);
